import { render, staticRenderFns } from "./GenericMSAList.vue?vue&type=template&id=5bcbc1f2&scoped=true"
import script from "./GenericMSAList.vue?vue&type=script&lang=js"
export * from "./GenericMSAList.vue?vue&type=script&lang=js"
import style0 from "./GenericMSAList.vue?vue&type=style&index=0&id=5bcbc1f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbc1f2",
  null
  
)

export default component.exports